export enum BrandingTypes {
  BMO = 'BMO',
  PRIVATE_LABEL = 'PL',
  CO_BRAND = 'Co-Brand',
}
